export default __webpack_public_path__ + "static/media/tandang-sora.5606cc4c.jpg";